export const libraries = ["places"] as (
  | "places"
  | "drawing"
  | "geometry"
  | "localContext"
  | "visualization"
)[];

export const defaultLatLng = {
  lat: 50,
  lng: 30,
};
